export enum UserRole {
  ADMIN = 'Admin',
  BASE_LEADER = 'BaseLeader',
  TEAM_LEADER = 'TeamLeader',
  VOLUNTEER = 'Volunteer',
  PARTNER = 'Partner',
  HOMEOWNER = 'Homeowner',
  Supporter='Supporter'
}

// Export individual role constants for direct usage
export const ADMIN_ROLE = UserRole.ADMIN;
export const BASE_LEADER_ROLE = UserRole.BASE_LEADER;
export const TEAM_LEADER_ROLE = UserRole.TEAM_LEADER;
export const VOLUNTEER_ROLE = UserRole.VOLUNTEER;
export const TEAM_LEADER_ROLE_ID = 3
export const VOLUNTEER_ROLE_ID = 4
export const PARTNER_ROLE = UserRole.PARTNER;
export const HOMEOWNER_ROLE = UserRole.HOMEOWNER;

export const ADMIN_ROLE_DESCRIPTION = {
  id: 1,
  name: UserRole.ADMIN,
  description: 'Full access to the system'
}

export const BASE_LEADER_ROLE_DESCRIPTION = {
  id: 2,
  name: UserRole.BASE_LEADER,
  description: 'Leads a specific base or region'
}

export const TEAM_LEADER_ROLE_DESCRIPTION = {
  id: 3,
  name: UserRole.TEAM_LEADER,
  description: 'Leads a team within a mission'
}

export const VOLUNTEER_ROLE_DESCRIPTION = {
  id: 4,
  name: UserRole.VOLUNTEER,
  description: 'Participates in missions and tasks'
}

export const PARTNER_ROLE_DESCRIPTION = {
  id: 5,
  name: UserRole.PARTNER,
  description: 'External partner contributing resources'
}

export const HOMEOWNER_ROLE_DESCRIPTION = {
  id: 6,
  name: UserRole.HOMEOWNER,
  description: 'Receives mission help'
}

export const SUPPORTER_ROLE_DESCRIPTION = {
  id: 6,
  name: UserRole.Supporter,
  description: 'Supports'
}


// Type for role descriptions
export type RoleDescription = {
  id: number;
  name: UserRole;
  description: string;
};

// Role descriptions that can be used in the UI
export const ROLE_DESCRIPTIONS: RoleDescription[] = [
  ADMIN_ROLE_DESCRIPTION,
  BASE_LEADER_ROLE_DESCRIPTION,
  TEAM_LEADER_ROLE_DESCRIPTION,
  VOLUNTEER_ROLE_DESCRIPTION,
  PARTNER_ROLE_DESCRIPTION,
  HOMEOWNER_ROLE_DESCRIPTION,
  SUPPORTER_ROLE_DESCRIPTION
];

